// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, onSnapshot,addDoc, setDoc, query, where, deleteDoc, getDocs  } from 'firebase/firestore';
import { getMessaging, getToken, onMessage, sendMulticast } from "firebase/messaging";
import { config } from "@/config/constants";
// Inicializar Firebase
const app = initializeApp(config.firebaseConfig);
const db = getFirestore(app);
const messaging = getMessaging(app);
const analytics = getAnalytics(app);
export { messaging,analytics,db };
